/* eslint-disable @typescript-eslint/naming-convention */

export type lineItemType = 'PRODUCT' | 'PARTS' | 'SERVICE' | 'BUNDLE';

export interface ProductObjectType {
  displayName: string;
  displayKey: string;
  value: lineItemType;
}

export enum ProductType {
  PRODUCT = 'PRODUCT',
	PARTS = 'PARTS',
	SERVICE = 'SERVICE',
	BUNDLE = 'BUNDLE',
}

export const productTypesArray: ProductObjectType[] = [{
  displayName: 'Product',
  displayKey: 'product.text',
  value: 'PRODUCT'
}, {
  displayName: 'Part',
  displayKey: 'text.part',
  value: 'PARTS'
}, {
  displayName: 'Service',
  displayKey: 'text.service',
  value: 'SERVICE'
}, {
  displayName: 'Bundle',
  displayKey: 'text.bundle',
  value: 'BUNDLE'
}];

export const attributeIcon = {
  'STRING':'ti-typography',
  'TEXT':'ti-typography',
  'OBJECT': 'ti-square-chevron-down',
  'DROPDOWN': 'ti-square-chevron-down',
  'DATE': 'ti-calendar-event',
  'DATETIME': 'ti-calendar-event',
  'NUMBER': 'ti ti-numbers',
  'BOOLEAN': 'ti ti-toggle-right',
  'TIME': 'ti ti-hourglass-empty',
  'CURRENCY': 'ti ti-currency-dollar',
  'DECIMAL': 'ti ti-currency-dollar',
  'LOOKUP': 'ti ti-search',
  'RADIO': 'ti ti-circle-dotted',
  'MULTI_ITEM': 'ti ti-brackets'
};

export const status = {
  estimates: [
    {
      'key': 'Draft',
      'value': 'DRAFT'
    },
    {
      'key': 'Sent',
      'value': 'AWAIT_RESPONSE'
    },
    {
      'key': 'Approved',
      'value': 'APPROVED'
    },
    {
      'key': 'Declined',
      'value': 'DECLINED'
    },
    {
      'key': 'Archived',
      'value': 'ARCHIVED'
    },
    {
      'key': 'Closed',
      'value': 'CLOSED'
    },
    {
      'key': 'Canceled',
      'value': 'CANCELED'
    },
    {
      'key': 'Change Requested',
      'value': 'REQUEST_CHANGE'
    }
  ]
};

export const assetStatus = [
  {
    'key': 'Ready to install',
    'value': 'READY_TO_INSTALL'
  },
  {
    'key': 'Installed',
    'value': 'INSTALLED'
  },
  {
    'key': 'Under service',
    'value': 'UNDER_SERVICE'
  },
  {
    'key': 'Removed',
    'value': 'REMOVED'
  },
  {
    'key': 'Obsolete',
    'value': 'OBSOLETE'
  },
  {
    'key': 'Online',
    'value': 'ONLINE'
  },
  {
    'key': 'Offline',
    'value': 'OFFLINE'
  },
  {
    'key': 'Needs Repair',
    'value': 'NEED_REPAIR'
  }
];

export const mapAssetStatus = {
  'INSTALLED': 'Installed',
  'READY_TO_INSTALL': 'Ready to Install',
  'UNDER_SERVICE': 'Under Service',
  'REMOVED': 'Removed',
  'OBSOLETE': 'Obsolete',
  'ONLINE': 'Online',
  'OFFLINE': 'Offline',
  'NEED_REPAIR': 'Needs Repair'
};
export const invoiceStatus = {
  'DRAFT': 'text.draft',
  'AWAIT_RESPONSE': 'text.sent',
  'AWAIT_PAYMENT': 'text.sent',
  'PARTIALLY_PAID': 'text.partially_paid',
  'PAID': 'text.paid',
  'BAD_DEBT': 'text.bad_debt',
  'ARCHIVED': 'text.archived',
  'CLOSED': 'text.closed',
  'CANCELED': 'text.canceled',
  'READY_TO_INVOICE': 'text.ready_to_invoice',
};
export const quotationStatus = {
  'DRAFT': 'text.draft',
  'AWAIT_RESPONSE': 'text.sent',
  'AWAIT_PAYMENT': 'text.sent',
  'APPROVED': 'accepted.text',
  'DECLINED': 'declined',
  'ARCHIVED': 'text.archived',
  'CLOSED': 'text.closed',
  'CANCELED': 'text.canceled',
  'REQUEST_CHANGE': 'text.change_requested',
};

export const contractApprovalStatus = {
     'AWAIT_APPROVAL' : 'text.pending',
	   'ON_HOLD': 'text.on_hold',
	   'APPROVED': 'text.approved',
	   'REJECTED': 'text.rejected',
	   'AWAIT_CUSTOMER_APPROVAL': 'text.await_customer_approval',
	   'CUSTOMER_REJECTED': 'text.customer_rejected',
	   'CUSTOMER_APPROVED': 'text.customer_approved'
};

export const moduleKey = {
  EMPLOYEE: 'USER',
  USER: 'USER',
  JOB: 'JOB',
  CUSTOMER: 'CUSTOMER',
  CUSTOMERS: 'CUSTOMER',
  ORGANIZATION: 'ORGANIZATION',
  PROPERTY: 'PROPERTY',
  MAPS: 'MAPS',
  TIMESHEET: 'TIMESHEET',
  TIMESHEETS: 'TIMESHEET',
  PRODUCT: 'PRODUCTS',
  PRODUCTS: 'PRODUCTS',
  ESTIMATE: 'ESTIMATES',
  ESTIMATES: 'ESTIMATES',
  INVOICE: 'INVOICE',
  SERVICE_CONTRACTS: 'SERVICE_CONTRACTS',
  SERVICE_CONTRACT: 'SERVICE_CONTRACTS',
  ASSET: 'ASSETS',
  ASSETS: 'ASSETS',
  REQUEST: 'REQUEST',
  PROJECT: 'PROJECT',
  TRANSFER_ORDER: 'TRANSFER_ORDER'
};

export const comparisonKeyArray = ['filter_rules', 'filterValue', 'page', 'count', 'sort', 'column'];

export const contractStatus = [
  {
    'key': 'Pending',
    'value': 'AWAIT_APPROVAL'
  },
  {
    'key': 'On Hold',
    'value': 'ON_HOLD'
  },
  {
    'key': 'Approved',
    'value': 'APPROVED'
  },
  {
    'key': 'Rejected',
    'value': 'REJECTED'
  },
  {
    'key': 'Await Customer Approval',
    'value': 'AWAIT_CUSTOMER_APPROVAL'
  },
  {
    'key': 'Customer Approved',
    'value': 'CUSTOMER_APPROVED'
  },
  {
    'key': 'Customer Rejected',
    'value': 'CUSTOMER_REJECTED'
  }
];

export const LANG_COUNTRY = {
  'data': {
    'IN': 'en-IN',
    'US': 'en-US',
    'RU': 'ru-RU',
    'ES': 'es-ES',
    'PT': 'pt-PT'
  }
};


export const errorMessage = {
  required: 'text.field_is_required',
  max: 'field.max.error.message',
  min: 'field.min.error.message',
  pattern: 'field.pattern.error.message'
};

export const regionalTaxCountry = ['US', 'CA'];

export const permissions = {
  'JOB': {
    'new': 'job.new',
    'edit': 'job.update',
    'clone': 'job.clone'
  },
  'CUSTOMER': {
    'new': 'customer.new',
    'edit': 'customer.update'
  },
  'INVOICE': {
    'new': 'invoice.new',
    'edit': 'invoice.update'
  },
  'ESTIMATES': {
    'new': 'estimate.new',
    'edit': 'estimate.update',
    'clone': 'estimate.clone'
  },
  'PRODUCTS': {
    'new': 'product.new',
    'edit': 'product.update'
  },
  'SERVICE_CONTRACTS': {
    'new': 'service_contract.new',
    'edit': 'service_contract.update'
  },
  'ASSETS': {
    'new': 'asset.new',
    'edit': 'asset.update'
  },
  'ORGANIZATION': {
    'edit': 'organization.update',
    'new': 'organization.new'
  },
  'PROPERTY': {
    'new': 'property.new',
    'edit': 'property.update'
  },
  'REQUEST': {
    'new': 'request.create',
    'edit': 'request.update'
  },
  'PROJECT': {
    'new': 'project.new',
    'edit': 'project.update',
    'clone': 'project.clone'
  },
  'TRANSFER_ORDER': {
    'new': 'product.create_transfer_order',
    'edit': 'product.update_transfer_order',
    'clone': 'product.create_transfer_order'
  },
  'PRICELIST': {
    'new': 'pricelist.new',
    'edit': 'pricelist.update',
    'clone': 'pricelist.new'
  },
  'USERS': {
    'new': 'user.new',
    'edit': 'user.update',
  }
};

export const routes = {
  'JOB': {
    job_list: {
      'path': '',
      'data': { module: 'JOB', page: 'job_list' },
    },
    job_new: {
      'path': '/new',
      'data': { module: 'JOB', page: 'job_new' },
    },
    job_details: {
      'path': '/:job_uid/details',
      'data': { module: 'JOB', page: 'job_details' },
    }
  },
  'CUSTOMER': {
    customer_list: {
      'path': '',
      'data': { module: 'CUSTOMER', page: 'customer_list' },
    },
    customer_new: {
      'path': '/new',
      'data': { module: 'CUSTOMER', page: 'customer_new' },
    },
    customer_update: {
      'path': '/:customer_uid/edit',
      'data': { module: 'CUSTOMER', page: 'customer_update' },
    },
    customer_details: {
      'path': '/:customer_uid/details',
      'data': { module: 'CUSTOMER', page: 'customer_details' },
    }
  },
  'ORGANIZATION': {
    organization_list: {
      'path': '',
      'data': { module: 'ORGANIZATION', page: 'organization_list' },
    },
    organization_new: {
      'path': '/new',
      'data': { module: 'ORGANIZATION', page: 'organization_new' },
    },
    organization_update: {
      'path': '/:organization_uid/edit',
      'data': { module: 'ORGANIZATION', page: 'organization_update' },
    },
    organization_details: {
      'path': '/:organization_uid/details',
      'data': { module: 'ORGANIZATION', page: 'organization_details' },
    }
  },
  'ASSET': {
    asset_list: {
      'path': '',
      'data': { module: 'ASSET', page: 'asset_list' },
    },
    asset_new: {
      'path': '/new',
      'data': { module: 'ASSET', page: 'asset_new' },
    },
    asset_update: {
      'path': '/:asset_uid/edit',
      'data': { module: 'ASSET', page: 'asset_update' },
    },
    asset_details: {
      'path': '/:asset_uid/details',
      'data': { module: 'ASSET', page: 'asset_details' },
    }
  },
  'PROPERTY': {
    property_list: {
      'path': '',
      'data': { module: 'PROPERTY', page: 'property_list' },
    },
    property_new: {
      'path': '/new',
      'data': { module: 'PROPERTY', page: 'property_new' },
    },
    property_update: {
      'path': '/:property_uid/edit',
      'data': { module: 'PROPERTY', page: 'property_update' },
    },
    property_details: {
      'path': '/:property_uid/details',
      'data': { module: 'PROPERTY', page: 'property_details' },
    }
  },
  'INVOICE': {
    invoice_list: {
      'path': '',
      'data': { module: 'INVOICE', page: 'invoice_list' },
    },
    invoice_new: {
      'path': '/new',
      'data': { module: 'INVOICE', page: 'invoice_new' },
    },
    invoice_update: {
      'path': '/:invoice_uid/edit',
      'data': { module: 'INVOICE', page: 'invoice_update' },
    },
    invoice_details: {
      'path': '/:invoice_uid/details',
      'data': { module: 'INVOICE', page: 'invoice_details' },
    }
  },
  'ESTIMATE': {
    estimate_list: {
      'path': '',
      'data': { module: 'ESTIMATE', page: 'estimate_list' },
    },
    estimate_new: {
      'path': '/new',
      'data': { module: 'ESTIMATE', page: 'estimate_new' },
    },
    estimate_update: {
      'path': '/:estimate_uid/edit',
      'data': { module: 'ESTIMATE', page: 'estimate_update' },
    },
    estimate_details: {
      'path': '/:estimate_uid/details',
      'data': { module: 'ESTIMATE', page: 'estimate_details' },
    }
  },
  'PROJECT': {
    project_list: {
      'path': '',
      'data': { module: 'PROJECT', page: 'project_list' },
    },
    project_new: {
      'path': '/new',
      'data': { module: 'PROJECT', page: 'project_new' },
    },
    project_update: {
      'path': '/:project_uid/edit',
      'data': { module: 'PROJECT', page: 'project_update' },
    },
    project_details: {
      'path': '/:project_uid/details',
      'data': { module: 'PROJECT', page: 'project_details' },
    }
  },
  'CALENDAR': {
    'calendar': {
      path: '',
      data: { 'module': 'CALENDAR', 'page': 'calender' }
    }
  },
  'DISPATCH_BOARD': {
    'dispatch_board': {
      path: '',
      data: { 'module': 'DISPATCH_BOARD', 'page': 'dispatch_board' }
    }
  },
  'MAPS': {
    'maps': {
      path: '',
      data: { 'module': 'MAPS', 'page': 'maps' }
    }
  },
  'REPORTS': {
    'report_list': {
      path: '',
      data: { 'module': 'REPORTS', 'page': 'report_list' }
    }
  }
};

export const objectPrefixBasedOnModuleMapping = {
  'SERVICE_CONTRACTS': 'contract',
  'PRODUCTS': 'product',
  'ASSETS': 'asset',
};

export const statusDisplayName = {
  'DRAFT': 'Draft',
  'IN_TRANSIT': 'In-Transit',
  'COMPLETED': 'Completed',
  'VOIDED': 'Voided',
  'ACTIVE': 'Active',
  'INACTIVE': 'Inactive'
};

export type TabDataKey = 'NAVIGATION' | 'STATUS_HISTORY';

export const modulesForFilter = {
  'JOB':'jobs',
  'CUSTOMER':'customers',
  'USER':'users',
  'INVOICE':'invoice',
  'ESTIMATE':'estimate',
  'REQUEST':'request',
  'SERVICE_CONTRACT':'service_contract',
  'ORGANIZATION':'organization',
  'PROPERTY':'property',
  'PROJECT':'projects',
};
export const emailValidation = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

export const modulesIcon = {
  JOB: 'heroicons_solid:briefcase',
  CUSTOMER: 'heroicons_solid:users',
  INVOICE: 'heroicons_solid:receipt-tax',
  ORGANIZATION: 'heroicons_solid:office-building',
  PROPERTY:'heroicons_solid:office-building-2',
  ESTIMATE:'heroicons_solid:calculator',
  PROJECT: 'heroicons_solid:clipboard-document-check',
  REQUEST:'heroicons_solid:wrench-screwdriver',
  USER:'heroicons_solid:user',
  TEAM:'heroicons_solid:user-group',
  SERVICE_CONTRACT:'heroicons_solid:document-duplicate',
  PRODUCT: 'heroicons_solid:wrench-screwdriver',
  ASSET: 'heroicons_solid:cube',
  RECURRING_JOBS: 'heroicons_solid:briefcase',
  PRICELIST: 'heroicons_solid:discount',
  SERVICE_TASKS: 'heroicons_solid:clipboard'
};
export const priority = {
  'LOW': 'text.low',
  'MEDIUM': 'text.medium',
  'HIGH': 'text.high',
  'URGENT': 'text.urgent',
};

export const URL_PATTERN = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', // fragment locator
  'i'
);

export const tableColumnIcon = {
  SINGLE_LINE:'ti-abc',
  MULTI_LINE:'ti-list',
  NUMBER: 'ti-123',
  DATE: 'ti-calendar-month',
  TIME:'ti-clock-hour-3',
  DATE_TIME:'ti-calendar-time',
  CHECKBOX: 'ti-circle-check',
  DROPDOWN: 'ti-select'
};
